export default function options (data) {
  try {
    return JSON.parse(data || '{}')  
  } catch (e) {
    return {}
  }
}